import { composeEntityDrawerSelectors } from '@bp/admins-shared/features/entity';

import type { CreditCard } from '../../models';
import { getEntityState } from '../feature.selectors';

import type { IState } from './credit-card.reducer';

export const CREDIT_CARD_DRAWER_SELECTORS = composeEntityDrawerSelectors<CreditCard, IState>(getEntityState);
